import "./arcade-anim.css";

/* 🎰 shared casino stage dressing — marquee bulbs + result light flood + flying chips */
export const MarqueeRow = ({ pos = "top", n = 24 }) => (
  <div className={`absolute inset-x-2 ${pos === "top" ? "top-1" : "bottom-1"} flex justify-between pointer-events-none z-10`}>
    {Array.from({ length: n }).map((_, i) => (
      <span key={i} className="arena-bulb w-1.5 h-1.5 rounded-full bg-[#F7B731]" style={{ animationDelay: `${((i + (pos === "top" ? 0 : 2)) % 4) * 0.22}s` }} />
    ))}
  </div>
);

const ChipSVG = ({ className = "", style, color = "#F7B731" }) => (
  <svg viewBox="0 0 40 40" className={`w-6 h-6 ${className}`} style={style}>
    <circle cx="20" cy="20" r="18" fill={color} stroke="#0B0E14" strokeWidth="2" />
    {[0, 60, 120, 180, 240, 300].map((a) => (
      <rect key={a} x="18" y="1" width="4" height="7" rx="1" fill="#fff" transform={`rotate(${a} 20 20)`} />
    ))}
    <circle cx="20" cy="20" r="10" fill="#0B0E14" />
    <text x="20" y="24.5" textAnchor="middle" fontSize="11" fontWeight="900" fill={color} fontFamily="monospace">$</text>
  </svg>
);

/* drop inside a `relative` stage: green/red flood + chips flying to the winner */
export const StageFX = ({ outcome }) => {
  if (outcome !== "win" && outcome !== "loss") return null;
  return (
    <>
      <div className={`absolute inset-0 pointer-events-none arena-flood ${outcome === "win" ? "bg-[#089981]" : "bg-[#F23645]"}`} />
      <div className="absolute left-1/2 top-1/2 pointer-events-none">
        {[0, 1, 2].map((i) => (
          <ChipSVG key={i} color={["#F7B731", "#53b9ff", "#F23645"][i]}
            className={`absolute ${outcome === "win" ? "arena-fly-l" : "arena-fly-r"}`}
            style={{ animationDelay: `${i * 0.12}s` }} />
        ))}
      </div>
    </>
  );
};

/* 🔥 escalating win-streak chip — the addictive "keep it going" loop */
export const StreakFlame = ({ n }) => {
  if (!n || n < 2) return null;
  const hot = n >= 5;
  return (
    <span data-testid="streak-flame" className={`flame-flicker inline-flex items-center gap-1 px-2 py-0.5 rounded-full border font-mono font-black text-[10px] ${hot
      ? "border-[#F23645]/70 text-[#ff7b86] bg-[#F23645]/15" : "border-[#F7B731]/70 text-[#F7B731] bg-[#F7B731]/10"}`}>
      🔥 {n} IN A ROW{hot ? " · ON FIRE" : ""}
    </span>
  );
};

/* 📸 crowd camera flashes — fires on big wins */
export const CameraFlashes = () => (
  <div className="absolute inset-0 pointer-events-none z-10">
    {[[8, 12], [22, 6], [40, 10], [58, 5], [74, 11], [88, 7], [15, 22], [67, 20], [93, 18]].map(([x, y], i) => (
      <span key={i} className="camera-flash absolute w-1.5 h-1.5 rounded-full bg-white"
        style={{ left: `${x}%`, top: `${y}%`, animationDelay: `${(i % 5) * 0.14}s` }} />
    ))}
  </div>
);
